import { render, staticRenderFns } from "./ThePersonalDiscountsInfo.vue?vue&type=template&id=30a7442d&functional=true&"
import script from "./ThePersonalDiscountsInfo.vue?vue&type=script&lang=js&"
export * from "./ThePersonalDiscountsInfo.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalDiscountsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports